import {GridLinkedContent} from '../components/GridContent'
import '../style.css';

export default function CD() {
  return (
  	<div className="content load-first">
        <h2>Multimedia Production</h2>

        <p>AI/nsiders is a podcast featuring Adam Russel, Director of the AI Division at USC's Information Science Institute, as he interviews professionals working at ISI about their work, their lives and their views on AI. As a producer of the podcast, I've run episode recordings, edited each episode, and led publishing. Following the success of the podcast, we have also begun <a href="https://open.spotify.com/show/5DLSvDpV5q7YTxViqCYnVq?si=16ce07df25ec4b66" id="valink">ISInsiders</a>, a version expanded to include various departments at ISI.</p>

        <div className="load-second grid-one">

        <GridLinkedContent link="https://www.isi.edu/news/69470/there-is-no-end-goal-for-ai-ethics-there-will-always-be-something-new-to-mitigate/"src="https://viterbischool.usc.edu/wp-content/uploads/2023/09/AInsiders-for-WP.png" caption="AI/nsiders Podcast" alt="Banner for AI/nsider Podcast"/>


          <div className="grid-content">
            <iframe className="spotify" title="ainsiders" src="https://open.spotify.com/embed/episode/40TdSSpdIaAC3kr1QdY76j?utm_source=generator" width="65%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
          </div>

        </div>

        <p>Below is a selection of media packages I've produced along with an example of my social video editing work. You can see more <a href="https://www.uscannenbergmedia.com/author/nina-moothedath/" class="show">here.</a></p>

        <div className="load-second grid-one">

          <div className="grid-content">
            <iframe className="spotify" title="metro" src="https://open.spotify.com/embed/episode/1bYmNF5fP9C5QEklwL7cxc?utm_source=generator&theme=0" width="65%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
          </div>

          <div class="grid-content">
            <iframe className="spotify" title="wonderland" src="https://open.spotify.com/embed/episode/6teuiwy3JvCyhtlegF82nC?utm_source=generator&theme=0" width="65%" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
          </div>

          <div class="grid-content">
             <iframe width="560" height="315" src="https://www.youtube.com/embed/NGWwF-XZguo?si=GukV-6xcNZpRMfA0" title="Zine YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

          </div>

          <div class="grid-content last-video">

            <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/L890g_DKDZc?si=-gUCcv4mSESf53_3" title="Rundown YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>

        </div>
        
      </div>
  );
}